<template>
	<div>
		<ref-tree-panel v-if="refType == 'tree'"
			:model="model"
			:defTreeData="defTreeData"
			:mulSelect="mulSelect"
			:checkStrictly="checkStrictly"
			:withParent="withParent"
      :areaNameSearch="areaNameSearch"
      ref="treePanelSearch"
			v-model="currentValue"
		></ref-tree-panel>
		<ref-tree-add-panel v-if="refType == 'treeMul'"
			:model="model"
			:filterMethod="treeFilterMethod"
			:defTreeData="defTreeData"
			:mulSelect="true"
			:checkStrictly="checkStrictly"
			:withParent="withParent"
			v-model="currentValue"
		></ref-tree-add-panel>
		<ref-tree-table-panel v-if="refType == 'treeTable'"
			:model="model"
			ref="refTreeTablePanel"
			:defTreeData="defTreeData"
			:mulSelect="mulSelect"
			:crossLevelSelection="crossLevelSelection"
			:columns="columns"
			:listData="listData"
      :shopId="shopId"
			@reLoadTable="reLoadTable"
			v-model="currentValue"
		></ref-tree-table-panel>
	</div>
</template>
<script>
	import RefTreePanel from './view/refTreePanel.vue';
	import RefTreeAddPanel from './view/refTreeAddPanel.vue';
	import RefTreeTablePanel from './view/refTreeTablePanel.vue';
	import modelRouter from './refModelRouter.js';
	export default{
		props:{
			refModel:Object,
			refCode:String,
			mulSelect:{
                type:Boolean,
                default:false
            },
            checkStrictly:{
                type:Boolean,
                default:false
            },
            crossLevelSelection:{
            	type:Boolean,
                default:false
            },
            withParent:{
                type:Boolean,
                default:false
            },
            treeFilterMethod:Function,  //用来对展示结果集进行过滤
            value:[Object,Array],
            areaNameSearch: String,
            shopId: String,
		},
		data(){
			var _model = this.refModel?this.refModel:modelRouter[this.refCode];
			var _refType = _model.refConfig.refType;
			return {
				model:_model,
				refType:_refType,
				defTreeData:[],
				currentValue:this.value,
				columns:_refType=='treeTable'?_model.getDefColumns():[],
				listData:_refType=='treeTable'?_model.createTableDatas():{},
			}
		},
		watch:{
            currentValue:function(v){
                this.$emit('input',v);
            },
            value:{
                immediate: true,
                handler:function(v, oldv){
                    if(v){

                    }else{
                        this.currentValue = null;
                    }
                }
            },
		},
        components: {
            RefTreePanel,
            RefTreeTablePanel,
            RefTreeAddPanel
        },
		created:function(){
      this.initData();
    },
		methods:{
			initData:function(){
          this.loadTreeData();
      },
      handleSearch:function() {
        this.$refs.treePanelSearch.handleDoSearch();
      },
			loadTreeData:function(){
				var _self = this;
				this.model.getClassData(function(data){
          _self.defTreeData=data;
          if ( _self.areaNameSearch ) {
            _self.$emit('handleParentClick');//当获得数据之后再次调用父组件方法
          }
        });
			},
			reLoadTable:function(searchParams, pageInfo){

        		var _self = this;
				var mulValue = [];
				if(_self.mulSelect){
					if(searchParams && searchParams.multipleSelection){
						mulValue = searchParams.multipleSelection;
						delete searchParams.multipleSelection;
					}
                }
//        		var mulValue = searchParams.multipleSelection;
				/*if(mulValue){
					delete searchParams.multipleSelection;
				}*/
        		this.model.getTableData(searchParams,pageInfo, function(data){
        			_self.listData = data;
        			if(_self.crossLevelSelection){
        				var rows = [];
        				mulValue.forEach(function(item){
        					data.tableDatas.forEach(function(child){
        						if(item.id == child.id){
        							_self.getChildCompFunction('refTreeTablePanel',child);
        						}
        					});
        				});
        				
        			}
        		});
			},
			/**
			*获取自组件中的方法
			*/
			getChildCompFunction(refName,row){
				var _self = this;
				if(row){
	                _self.$nextTick(function(){
	                	if(_self.$refs[refName]){
							_self.$refs[refName].setCheckedTableRows(row);
						}
	                });	
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pub/components/baseRef/refPanel.vue